<template>
    <div
        v-if="data"
        @click="goToVault(data)"
        class="vault-block"
        :class="[itemCss]"
    >
        <div class="head-caption">
            <span v-if="data.is_il">PHYSICAL -</span>
            {{ data.type.replace("_", "-") }}
        </div>
        <b-row no-gutters>
            <b-col>
                <div class="icon">
                    <img :src="itemIcon" :alt="data.token + ' image'" />
                </div>
            </b-col>
        </b-row>
        <b-row no-gutters>
            <b-col style="display: flex; justify-content: center">
                <div
                    class="head-block"
                    style="display: flex; flex-direction: column; align-items: center"
                >
                    <div class="caption bigger">{{ this.generateVaultName(data) }}</div>
                    <div class="caption">
                        <div v-if="data.is_il" style="text-align: center;">PHYSICAL</div>
                        {{ data.type.replace("_", "-") }}
                    </div>
                    <div class="caption">{{ data.time_period }}</div>
                </div>
            </b-col>
        </b-row>

        <div class="percentage">
            {{ apy < 0 ? `${moneyFormat(apy)}` : `+${moneyFormat(apy)}` }}%
        </div>
        <div class="percentage-description">Current Projected Yield (APY)</div>
        <div class="statistics">
            <div class="row mbo-1">
                <div class="col-6">Time to Expiry</div>
                <div class="col-6 text-right font-weight-bold">
                    <count-down
                        v-if="data"
                        :expiry="data.vault_detail.expiry"
                        :vault="data"
                    />
                    <!--<span id="countdown" v-if="expiryIsPassed || true"></span>
                    <span v-else>
                        {{ getExpiry }}
                    </span>-->
                </div>
            </div>
            <div class="row">
                <div class="col-6">Strike Price</div>
                <div class="col-6 text-right font-weight-bold">
                    {{ getStrike }}
                </div>
            </div>
            <div class="row" v-if="data.delta_value">
                <div class="col-6">Delta</div>
                <div class="col-6 text-right font-weight-bold">
                    {{ data.delta_value }}
                </div>
            </div>
            <div class="row">
                <div class="col-3">Deposits</div>
                <div
                    class="col-9 text-right font-weight-bold pl-0"
                    style="text-transform: uppercase"
                    v-bind:class="getNumberClass(this.currBalance.length)"
                >
                    {{ fixDeposit }}
                    {{ data.real_token_symbol }}
                </div>
            </div>
            <!-- <div class="row mbo-1">
                <div class="col-12">
                    <progress-bar
                        :value="data.total_deposit"
                        :color="data.accent_color"
                        :max-value="+data.max_deposit"
                    >
                    </progress-bar>
                </div>
            </div> -->
            <div class="row fault-bar">
                <b-col cols="12" class="p-0">
                    <b-progress
                        :value="currBalance"
                        :max="data.max_deposit"
                        class="mb-1 mt-1"
                    ></b-progress>
                </b-col>
            </div>
            <div class="row mbo-3">
                <div class="col-3">Max</div>
                <div
                    class="col-9 pl-0 text-right font-weight-bold"
                    style="text-transform: uppercase"
                    v-bind:class="getNumberClass(this.data.max_deposit.length)"
                >
                    {{ fixMax }}
                </div>
            </div>
            <div class="row">
                <div class="col-6">Your Position</div>
                <div
                    class="col-6 text-right font-weight-bold"
                    style="text-transform: uppercase"
                >
                    {{ fixMyPosition }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProgressBar from "./ProgressBar";
import moment from "moment";
import { mapState, mapGetters } from "vuex";
export default {
    components: { ProgressBar },
    props: {
        data: {
            type: Object,
            default: () => {
                return null;
            }
        },
        deposits: {
            default() {
                return [4560187, 3192130, 6840280, 8208336, 1368056, 4012964];
            }
        },
    },
    data() {
        return {
            DURATION_IN_SECONDS: {
                epochs: ["year", "month", "day", "hour", "minute"],
                year: 31536000,
                month: 2592000,
                day: 86400,
                hour: 3600,
                minute: 60
            },
            myPosition: 0,
            currBalance: 0
        };
    },
    computed: {
        ...mapState(["wallet"]),
        ...mapGetters({
            walletProvider: "wallet/getWalletProvider",
        }),
        fixDeposit() {
            if (this.currBalance > this.data.max_deposit) {
                return this.moneyFormat(+this.data.max_deposit);
            } else {
                return this.moneyFormat(+this.currBalance);
            }
        },
        fixMax() {
            if(this.data.max_deposit){
                return this.moneyFormat(+this.data.max_deposit) + ` ${this.data.real_token_symbol}`;
            } else return "---";

        },
        fixMyPosition() {
            if(this.myPosition){
                return this.moneyFormat(+this.myPosition) + ` ${this.data.real_token_symbol}`;
            } else return "---";

        },
        // calcDeposits() {
        //     //+this.data.total_exit)/1e18 +
        //     return +this.data.total_asset / 1e18;
        // },
        getStrike() {
            if (this.data == null) return "---";
            return this.formatCurrency(+this.data.vault_detail.strike_price);
        },
        getExpiry() {
            return this.timeSince(this.data.vault_detail.expiry) + " ago";
        },
        itemCss() {
            //return `${this.data.nut}-card`;
            return `${this.data.color}-card`;
        },
        itemIcon() {
            return `/images/crypto-icons/icon-coin-${this.data.token}.svg`;
        },
        expiryIsPassed() {
            const expiryDate = new Date(
                this.data.vault_detail.expiry_timestamp * 1000
            ).getTime();
            const now = new Date().getTime();

            if (expiryDate > now) {
                this.countdown();
                return true;
            } else return false;
        },
        // calcDeposits() {
        //     //+this.data.total_exit)/1e18 +
        //     return +this.data.total_deposit;
        // },
        // getStrike() {
        //     if (this.data == null) return "---";
        //     return parseFloat(
        //         (+this.data.vault_detail.strike_price).toFixed(6)
        //     );
        // },
        getExpiry() {
            if (this.data.vault_detail.expiry == null) return "---";
            return moment().to(this.data.vault_detail.expiry);
        },
        apy() {
            if (this.data.apy == 0) return 0;
            else return parseFloat(this.data.apy).toFixed(2);
        }
    },
    methods: {
        moment,
        async getVaultPosition() {
            let myPositionData = {};
            let token = this.wallet.tokens.find(
                item =>
                    item.symbol == this.data.real_token_symbol &&
                    item.network == this.data.network
            );
            if (token == undefined || !this.walletProvider) return 0;

            myPositionData = await this.$store.dispatch(
                "vaults/getMyPosition",
                {
                    vault: this.data,
                    decimals: token.decimals
                }
            );

            if (myPositionData.activeDeposit) return this.moneyFormat(myPositionData.activeDeposit);
            return 0;

            // if (
            //     this.data.vault_detail.epoch > myPositionData.queuedEpoch &&
            //     myPositionData.queuedEpoch != 0
            // ) {
            //     return myPositionData.queuedDeposits;
            // } else if (
            //     this.data.vault_detail.epoch == myPositionData.queuedEpoch
            // ) {
            //     return myPositionData.queuedDeposits;
            // } else if (
            //     myPositionData.queuedEpoch == 0 &&
            //     myPositionData.position > 0
            // ) {
            //     return myPositionData.position;
            // } else {
            //     if(myPositionData.deposit) return this.moneyFormat(myPositionData.deposit/token.decimals);
            //     return 0;
            // }
        },
        formatCurrency(val) {
            const formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            return formatter.format(val);
        },
        goToVault(vault) {
            this.$router.push(
                `/basic/vaults/${vault.chain_id}/${vault.contract_address}`
            );
        },
        // countdown() {
        //     var countDownDate = new Date(
        //         this.data.vault_detail.expiry_timestamp * 1000
        //     ).getTime();

        //     // Update the count down every 1 second
        //     var x = setInterval(function() {
        //         // Get today's date and time
        //         var now = new Date().getTime();

        //         // Find the distance between now and the count down date
        //         var distance = countDownDate - now;

        //         // Time calculations for days, hours, minutes and seconds
        //         var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        //         var hours = Math.floor(
        //             (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        //         );
        //         var minutes = Math.floor(
        //             (distance % (1000 * 60 * 60)) / (1000 * 60)
        //         );
        //         var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        //         // Display the result in the element with id="countdown"
        //         document.getElementById("countdown").innerHTML =
        //             days +
        //             "d " +
        //             hours +
        //             "h " +
        //             minutes +
        //             "m " +
        //             seconds +
        //             "s ";

        //         // If the count down is finished, write some text
        //         if (distance < 0) {
        //             clearInterval(x);
        //             document.getElementById("countdown").innerHTML = "EXPIRED";
        //         }
        //     }, 1000);
        // },
        getDuration(seconds) {
            var epoch, interval;

            for (var i = 0; i < this.DURATION_IN_SECONDS.epochs.length; i++) {
                epoch = this.DURATION_IN_SECONDS.epochs[i];
                interval = Math.floor(
                    seconds / this.DURATION_IN_SECONDS[epoch]
                );
                if (interval >= 1) {
                    return {
                        interval: interval,
                        epoch: epoch
                    };
                }
            }
        },
        timeSince(date) {
            var seconds = Math.floor((new Date() - new Date(date)) / 1000);
            var duration = this.getDuration(seconds);
            var suffix =
                duration.interval > 1 || duration.interval === 0 ? "s" : "";
            return duration.interval + " " + duration.epoch + suffix;
        },
        async setCurrentBalance() {
            if (this.data !== undefined) {
                const token = this.$store.state.wallet.tokens.find(
                    a =>
                        a.symbol == this.data.real_token_symbol &&
                        a.network == this.data.network
                );

                if (token == undefined) return;

                this.currBalance = await this.$store.dispatch(
                    "vaults/getVaultCurrentDeposit",
                    {
                        vault_contract: this.data.contract_address,
                        token: token,
                        vault: this.data
                    }
                );
            }
        },
        getNumberClass(length){
            if(length > 13) return "number-overflow";
        }
    },
    async mounted() {
        await this.setCurrentBalance();

        this.myPosition = await this.getVaultPosition();
        // this.countdown();
    },
    watch: {
        data: function(newVault) {
            //detect changes in vault and update the current balance
            this.setCurrentBalance();
        }
    }
};
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";

.vault-block {
    cursor: pointer;
    font-family: "Exo";
    border-radius: 0.694445vw;
    padding: 1.4vw;
    position: relative;
    font-weight: normal;
    font-size: 0.83333vw;
    line-height: 1.25vmax;
    cursor: pointer;
    box-shadow: none;
    width: 20vw;
    height: auto;
    margin: auto;

    .number-overflow {
        @media only screen and (min-width: 1440px) {
            font-size: 0.5944444444444444vw;
        }
    }

    // @media only screen and(min-width: 1440px) {
    //     max-height: 32.600vw;
    // }

    @media only screen and(min-width: 2500px) {
        font-size: calc(18px + 0.2vw);
    }

    &:hover {
        box-shadow: unset;
    }
    .col-md-4 {
        padding-right: 1.13vw;
        padding-left: 1.13vw;
    }
    .head-caption {
        font-family: "Bungee Inline";
        border-radius: 0.2777777vw;
        width: max-content;
        padding: 2.59% 3.886%;
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        top: 0%;
        margin: auto;

        font-weight: normal;
        font-size: 0.83333vw;
        line-height: 0.84vw;
        text-align: center;
    }
    .head-block {
        margin: auto 7.88%;
        .caption {
            font-family: "Bungee";
            font-style: normal;
            font-weight: normal;
            // font-size: 14px;
            font-size: 0.97222vw;
            line-height: 1.4vmax;
            text-align: left;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            margin-bottom: 2.12%;
            &.bigger {
                font-size: 1.38889vw;
                line-height: 1.4vmax;
                margin-bottom: 5.27%;
            }
        }
    }
    .icon {
        margin: 5%; //15.75%;
        text-align: center;
        img {
            width: 4.445vw;
            height: 4.445vw;
            // width: 58.8%;
            // height: 58.8%;
        }
    }
    .percentage {
        padding-top: 0.69442vw;
        margin-top: 4%;
        margin-bottom: 4%;
        font-family: "Bungee";
        font-style: normal;
        font-weight: normal;
        font-size: 2.36111vw;
        line-height: 2.1vmax;
        text-align: center;
        letter-spacing: 0.04em;
    }
    .percentage-description {
        margin-bottom: 5.515%;
        padding-bottom: 0.69442vw;
        font-family: "Exo";
        font-style: normal;
        font-weight: 600;
        font-size: 0.694445vw; //$small-x-text;
        line-height: 0.91vmax;
        text-align: center;
        text-transform: uppercase;

        @media only screen and (min-width: 2500px) {
            font-size: calc(18px + 0.1vw);
        }
    }
    .statistics {
        .my-progress-bar .my-progress-bar__container {
            margin-top: 2%;
            height: 0.556vw;
        }
        .my-progress-bar .my-progress-bar__container::before,
        .my-progress-bar .my-progress-bar__container::after {
            height: 0.556vw;
        }
    }
    .fault-bar {
        margin: 6px 0;
    }
    //&.acorn-card {
    &.green-card {
        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0) 100%
        );
        border: 1px solid $primary-1;
        color: $primary-4;
        box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        -webkit-box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        -moz-box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        .head-caption {
            background: $primary-5;
            border: 1px solid $primary-1;
            color: $primary-1;
            box-shadow: 2px 0px 20px rgba(110, 226, 159, 0.3);
        }
        .head-block {
            .caption {
                color: $primary-4;
            }
        }
        .progress {
            .progress-bar {
                background: $primary-1 !important;
                opacity: 0.8;
            }
        }
        .percentage {
            color: #b6f7d1;
            border-top: 0.5px solid $primary-1;
        }
        .percentage-description {
            color: #b6f7d1;
            border-bottom: 0.5px solid $primary-1;
        }
    }
    //&.walnut-card {
    &.orange-card {
        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0) 100%
        );
        border: 1px solid $primary-3;
        color: $primary-4;
        box-shadow: 1px 3px 20px 1px rgba(220, 152, 21, 0.4);
        -webkit-box-shadow: 1px 3px 20px 1px rgba(220, 152, 21, 0.4);
        -moz-box-shadow: 1px 3px 20px 1px rgba(220, 152, 21, 0.4);
        .head-caption {
            background: $primary-5;
            border: 1px solid $primary-3;
            color: $primary-3;
            box-shadow: 2px 0px 20px rgba(220, 152, 21, 0.3);
        }
        .head-block {
            .caption {
                color: $primary-4;
            }
        }
        .progress {
            .progress-bar {
                background: $primary-3 !important;
                opacity: 0.8;
            }
        }
        .percentage {
            color: #f7e1b6;
            border-top: 0.5px solid $primary-3;
        }
        .percentage-description {
            color: #f7e1b6;
            border-bottom: 0.5px solid $primary-3;
        }
    }

    &.light-orange-card {
        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0) 100%
        );
        border: 1px solid $light-orange;
        color: $primary-4;
        box-shadow: 1px 3px 20px 1px rgba(220, 152, 21, 0.4);
        -webkit-box-shadow: 1px 3px 20px 1px rgba(220, 152, 21, 0.4);
        -moz-box-shadow: 1px 3px 20px 1px rgba(220, 152, 21, 0.4);
        .head-caption {
            background: $primary-5;
            border: 1px solid $light-orange;
            color: $light-orange;
            box-shadow: 2px 0px 20px rgba(220, 152, 21, 0.3);
        }
        .head-block {
            .caption {
                color: $primary-4;
            }
        }
        .progress {
            .progress-bar {
                background: $light-orange !important;
                opacity: 0.8;
            }
        }
        .percentage {
            color: #ffad4c;
            border-top: 0.5px solid $light-orange;
        }
        .percentage-description {
            color: #ffad4c;
            border-bottom: 0.5px solid $light-orange;
        }
    }
    //&.almond-card {
    &.blue-card {
        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0) 100%
        );
        border: 1px solid $primary-2;
        color: $primary-4;
        box-shadow: 1px 3px 20px 1px rgba(97, 113, 255, 0.4);
        -webkit-box-shadow: 1px 3px 20px 1px rgba(97, 113, 255, 0.4);
        -moz-box-shadow: 1px 3px 20px 1px rgba(97, 113, 255, 0.4);
        .head-caption {
            background: $primary-5;
            border: 1px solid $primary-2;
            color: $primary-2;
            box-shadow: 2px 0px 20px rgba(97, 113, 255, 0.3);
        }
        .head-block {
            .caption {
                color: $primary-4;
            }
        }
        .progress {
            .progress-bar {
                background: $primary-2 !important;
                opacity: 0.8;
            }
        }
        .percentage {
            color: #b6bcf7;
            border-top: 0.5px solid $primary-2;
        }
        .percentage-description {
            color: #b6bcf7;
            border-bottom: 0.5px solid $primary-2;
        }
    }

    &.light-blue-card {
        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0) 100%
        );
        border: 1px solid $light-blue;
        color: $primary-4;
        box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        -webkit-box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        -moz-box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        .head-caption {
            background: $primary-5;
            border: 1px solid $light-blue;
            color: $light-blue;
            box-shadow: 2px 0px 20px rgba(110, 226, 159, 0.3);
        }
        .head-block {
            .caption {
                color: $primary-4;
            }
        }
        .progress {
            .progress-bar {
                background: $light-blue !important;
                opacity: 0.8;
            }
        }
        .percentage {
            color: #99d4ff;
            border-top: 0.5px solid $light-blue;
        }
        .percentage-description {
            color: #99d4ff;
            border-bottom: 0.5px solid $light-blue;
        }
    }

    &.light-purple-card {
        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0) 100%
        );
        border: 1px solid $light-purple;
        color: $primary-4;
        box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        -webkit-box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        -moz-box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        .head-caption {
            background: $primary-5;
            border: 1px solid $light-purple;
            color: $light-purple;
            box-shadow: 2px 0px 20px rgba(110, 226, 159, 0.3);
        }
        .head-block {
            .caption {
                color: $primary-4;
            }
        }
        .progress {
            .progress-bar {
                background: $light-purple !important;
                opacity: 0.8;
            }
        }
        .percentage {
            color: #d060f7;
            border-top: 0.5px solid $light-purple;
        }
        .percentage-description {
            color: #d060f7;
            border-bottom: 0.5px solid $light-purple;
        }
    }

    &.light-pink-card {
        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0) 100%
        );
        border: 1px solid $light-pink;
        color: $primary-4;
        box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        -webkit-box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        -moz-box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        .head-caption {
            background: $primary-5;
            border: 1px solid $light-pink;
            color: $light-pink;
            box-shadow: 2px 0px 20px rgba(110, 226, 159, 0.3);
        }
        .head-block {
            .caption {
                color: $primary-4;
            }
        }
        .progress {
            .progress-bar {
                background: $light-pink !important;
                opacity: 0.8;
            }
        }
        .percentage {
            color: $light-pink;
            border-top: 0.5px solid $light-pink;
        }
        .percentage-description {
            color: $light-pink;
            border-bottom: 0.5px solid $light-pink;
        }
    }

    &.light-lime-card {
        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0) 100%
        );
        border: 1px solid $light-lime;
        color: $primary-4;
        box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        -webkit-box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        -moz-box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        .head-caption {
            background: $primary-5;
            border: 1px solid $light-lime;
            color: $light-lime;
            box-shadow: 2px 0px 20px rgba(110, 226, 159, 0.3);
        }
        .head-block {
            .caption {
                color: $primary-4;
            }
        }
        .progress {
            .progress-bar {
                background: $light-lime !important;
                opacity: 0.8;
            }
        }
        .percentage {
            color: $light-lime;
            border-top: 0.5px solid $light-lime;
        }
        .percentage-description {
            color: $light-lime;
            border-bottom: 0.5px solid $light-lime;
        }
    }

    &.light-yellow-card {
        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0) 100%
        );
        border: 1px solid $light-yellow;
        color: $primary-4;
        box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        -webkit-box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        -moz-box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        .head-caption {
            background: $primary-5;
            border: 1px solid $light-yellow;
            color: $light-yellow;
            box-shadow: 2px 0px 20px rgba(110, 226, 159, 0.3);
        }
        .head-block {
            .caption {
                color: $primary-4;
            }
        }
        .progress {
            .progress-bar {
                background: $light-yellow !important;
                opacity: 0.8;
            }
        }
        .percentage {
            color: $light-yellow;
            border-top: 0.5px solid $light-yellow;
        }
        .percentage-description {
            color: $light-yellow;
            border-bottom: 0.5px solid $light-yellow;
        }
    }

    &.light-purple-2-card {
        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0) 100%
        );
        border: 1px solid $light-purple-2;
        color: $primary-4;
        box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        -webkit-box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        -moz-box-shadow: 1px 3px 20px 1px rgba(110, 226, 159, 0.4);
        .head-caption {
            background: $primary-5;
            border: 1px solid $light-purple-2;
            color: $light-purple-2;
            box-shadow: 2px 0px 20px rgba(110, 226, 159, 0.3);
        }
        .head-block {
            .caption {
                color: $primary-4;
            }
        }
        .progress {
            .progress-bar {
                background: $light-purple-2 !important;
                opacity: 0.8;
            }
        }
        .percentage {
            color: $light-purple-2;
            border-top: 0.5px solid $light-purple-2;
        }
        .percentage-description {
            color: $light-purple-2;
            border-bottom: 0.5px solid $light-purple-2;
        }
    }

    &.red-card {
        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0) 100%
        );
        border: 1px solid $primary-6;
        color: $primary-4;
        box-shadow: 1px 3px 20px 1px rgba(97, 113, 255, 0.4);
        -webkit-box-shadow: 1px 3px 20px 1px rgba(97, 113, 255, 0.4);
        -moz-box-shadow: 1px 3px 20px 1px rgba(97, 113, 255, 0.4);
        .head-caption {
            background: $primary-5;
            border: 1px solid $primary-6;
            color: $primary-6;
            box-shadow: 2px 0px 20px rgba(97, 113, 255, 0.3);
        }
        .head-block {
            .caption {
                color: $primary-4;
            }
        }
        .progress {
            .progress-bar {
                background: $primary-6 !important;
                opacity: 0.8;
            }
        }
        .percentage {
            color: #f7b4b4;
            border-top: 0.5px solid $primary-6;
        }
        .percentage-description {
            color: #f7b4b4;
            border-bottom: 0.5px solid $primary-6;
        }
    }
}
@media screen and (min-width: 0px) and (max-width: 768px) {
    .vault-block {
        border-radius: 10px; //1.3vmax;
        padding: 20px;
        font-size: 12px;
        line-height: 18px;
        width: auto;
        height: auto;

        .head-caption {
            width: auto; //111px;
            padding: 5px;
            font-size: 12px;
            line-height: 10px;
        }
        .head-block {
            margin: auto 7.88%;
            .caption {
                font-size: 14px;
                line-height: 21px;
                margin-bottom: 2.12%;
                &.bigger {
                    font-size: 20px;
                    line-height: 21px;
                    margin-bottom: 5.27%;
                }
            }
        }
        .icon {
            margin: 20px;
            text-align: center;
            img {
                width: 64px;
                height: 64px;
            }
        }
        .percentage {
            padding-top: 10px;
            margin-top: 0;
            margin-bottom: 5px;
            font-size: 34px;
            line-height: 41px;
        }
        .percentage-description {
            margin-bottom: 15px;
            padding-bottom: 10px;
            font-size: 10px;
            line-height: 15px;
        }
        .statistics {
            .my-progress-bar .my-progress-bar__container {
                margin-top: 5px;
                height: 10px;
            }
            .my-progress-bar .my-progress-bar__container::before,
            .my-progress-bar .my-progress-bar__container::after {
                height: 10px;
            }
        }
    }
}
</style>
